import { ReactNode } from 'react'

export function AdvancedField(props: { children: ReactNode }) {
  // TODO
  return props.children
}
